var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.oferta || _vm.packFoto)?_c('IndexSubirFotos',{attrs:{"oferta":_vm.oferta,"packFoto":_vm.packFoto}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }